<template>
  <div class="review-modal-data-divider">
    <v-layout row>
      <v-flex xs4 />
      <v-flex xs8>
        <v-divider class="grey lighten-3" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  export default {
    name: 'DataDivider'
  }
</script>

<style lang="scss">
  .review-modal-data-divider {
    .layout.row {
      margin-top: 0 !important;
      margin-bottom: 0 !important;

      .flex {
        padding-top: 13px;
        padding-bottom: 13px;
      }
    }
  }
</style>
